import { themeMaterial } from 'ag-grid-community';

const lightGrey = '#F6F5F3';
const mediumGrey = '#DBD7D1';
const darkGrey = '#28272C';

export const tableCustomTheme = themeMaterial.withParams({
  headerHeight: 56,
  // TODO: Refactor this color to be based on palette
  headerBackgroundColor: mediumGrey,
  headerFontWeight: 600,
  headerFontSize: 16,
  // TODO: Refactor this color to be based on palette
  headerTextColor: darkGrey,
  // TODO: Refactor this color to be based on palette
  textColor: '#28272c',
  fontSize: 16,
  fontFamily: 'Instrument Sans, Arial, sans-serif',
  headerCellHoverBackgroundColor: 'transparent',
  headerRowBorder: 'transparent',
  rowBorder: `1px solid ${lightGrey}`,
  headerColumnResizeHandleColor: '#FFF',
  headerColumnResizeHandleWidth: 1,
  headerColumnResizeHandleHeight: 30,
  cellHorizontalPadding: 15,
  selectedRowBackgroundColor: '#EFE1FF'
});
